import { TweenVars } from '@1x2network/tweens'
import { arrayUtils } from '@1x2network/utils_array'
import gsap from 'gsap'
import { Spine } from 'pixi-spine'

/**
 * Helper functions for working with spines
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

/**
 * Tween tint on a spine or set of spines
 * @param target spines to tween
 * @param tint tint to apply
 * @param tweenVars gsap specific vars
 * @returns tween animation
 */
export function tweenTint(target: Spine | Spine[], tint: number, tweenVars: TweenVars = {}) {
    const targets = arrayUtils.toArray(target)
    return gsap.to(targets, {
        ease: 'none',
        ...tweenVars,
        pixi: { tint },
        onUpdate: () => {
            targets.forEach((t) => {
                if (t.autoUpdate) return
                t.update(0)
            })
        },
    })
}
